"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Audit/ScrollLoader.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

// Empty pages in a row before the list stops loading on its own.
 const MAX_EMPTY_PAGES = 5; exports.MAX_EMPTY_PAGES = MAX_EMPTY_PAGES











/* The end of the audit table's scroll area: it loads the next page when it
 * comes within reach of the bottom (AU-4), says when it is loading, offers
 * Try again after a failure, and stops after a run of empty pages so a
 * narrow filter over a long range doesn't keep reading by itself. Without
 * IntersectionObserver it falls back to a Load more button. */
const ScrollLoader = ({ hasMore, isLoading, hasError, hasRows, emptyPages, onLoad, onKeepSearching }) => {
  const sentinel = _react.useRef(null)
  const isStalled = emptyPages >= exports.MAX_EMPTY_PAGES
  const canWatch = typeof IntersectionObserver !== 'undefined'
  const shouldWatch = canWatch && hasMore && !isLoading && !hasError && !isStalled

  _react.useEffect.call(void 0, () => {
    const el = sentinel.current
    if (!shouldWatch || !el) return
    const observer = new IntersectionObserver(
      entries => { if (entries.some(e => e.isIntersecting)) onLoad() },
      { root: el.closest('.campaign--table--wrapper'), rootMargin: '0px 0px 300px 0px' },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [shouldWatch, onLoad])

  if (hasError) {
    return (
      _react2.default.createElement('div', { className: "audit-more audit-more--error" , role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}, "Couldn't load more events."

        , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: onLoad, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}, "Try again" )
      )
    )
  }
  if (!hasMore) {
    return hasRows ? _react2.default.createElement('div', { className: "audit-more audit-more--end" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "No more events for these dates."     ) : null
  }
  if (isStalled) {
    return (
      _react2.default.createElement('div', { className: "audit-more", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}, "Nothing more matches yet."

        , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: onKeepSearching, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Keep searching" )
      )
    )
  }
  if (!canWatch) {
    return (
      _react2.default.createElement('div', { className: "audit-more", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
        , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , disabled: isLoading, onClick: onLoad, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "Load more" )
      )
    )
  }
  return (
    _react2.default.createElement('div', { ref: sentinel, className: "audit-more", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
      ,  isLoading && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('span', { className: "audit-more--spinner", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}} )
          ,  hasRows ? 'Loading more events…' : 'Searching for matching events…' 
        )
      )
    )
  )
}

exports. default = ScrollLoader
